export default __webpack_public_path__ + "static/media/blog6.26fa75bb.jpg";